export default {
    "Team.index.069632-0": "我们的团队",
    "Team.index.069632-1": "纵横四海拥有业内最专业的维保团队，对维保服务人员进行定期的培训，实行严格的四级培训体系，以保障我们维保人员的服务质量。",
    "Team.index.069632-2": "萨拉·多伊",
    "Team.index.069632-3": "产品设计师",
    "Team.index.069632-4": "Sara 是 XYZ 背后的产品设计师。在",
    "Team.index.069632-5": "上关注她。",
    "Team.index.069632-6": "尼克·多伊",
    "Team.index.069632-7": "全栈开发人员",
    "Team.index.069632-8": "Nick 是一位全栈开发人员，专长于构建 XYZ。在",
    "Team.index.069632-9": "上关注他，获取最新的开发技巧，并在他的",
    "Team.index.069632-10": "上查看有用的开源工具",
    "Team.index.571669-0": "Sara 是 XYZ 背后的",
    "Team.index.571669-1": "。在",
    "Team.index.571669-2": "Nick 是一位",
    "Team.index.571669-3": "，专长于构建 XYZ。在"
}